export const PLAYER_COLORS = ['red', 'green', 'yellow', 'blue', 'black', 'purple', 'orange', 'pink', 'turquoise', 'clear'];
const ALL_COLORS = [...PLAYER_COLORS, 'neutral', 'bronze'];
